export function getQuestionStaticValues(
  questionType: string,
  assetType: string,
): {summary: string; description: string} {
  console.log('🔍 getQuestionStaticValues called with:', {
    questionType,
    assetType,
  });

  const summaryMap: Record<string, Record<string, string>> = {
    READ_SENTENCE: {
      PHOTO: 'Look at the photo and read the sentence aloud',
      VIDEO: 'Watch carefully and read the sentence aloud',
      default: 'Look at the photo and read the sentence aloud',
    },
    MISSING_WORD: {
      PHOTO:
        'Look at the photo and read the sentence, filling in the missing word',
      VIDEO:
        'Watch the video and read the sentence, filling in the missing word',
      default:
        'Look at the photo and read the sentence, filling in the missing word',
    },
    MISSING_LETTERS: {
      PHOTO:
        'Look at the photo and read the word, completing the missing letters',
      VIDEO:
        'Watch the video and read the word, completing the missing letters',
      default:
        'Look at the photo and read the word, completing the missing letters',
    },
    CHOICES: {
      PHOTO: 'Look at the photo and choose the correct answer',
      VIDEO: 'Watch the video and choose the correct answer',
      default: 'Look at the photo and choose the correct answer',
    },
    TRANSCRIBE_AND_SCORE: {
      PHOTO: 'Look at the photo and answer the question by speaking',
      VIDEO: 'Watch the video and answer the question by speaking',
      default: 'Look at the photo and answer the question by speaking',
    },
    DESCRIBE_IMAGE: {
      PHOTO: 'Look at the photo and describe what you see',
      VIDEO: 'Watch the video and describe what you see',
      default: 'Look at the photo and describe what you see',
    },
    FREE_TEXT_ONLY_PRONUNCIATION: {
      PHOTO: 'Look at the photo and speak about the topic',
      VIDEO: 'Watch the video and speak about the topic',
      default: 'Look at the photo and speak about the topic',
    },
    COMPREHENSION: {
      PHOTO:
        'Look at the photo, read the sentence, and choose the correct word',
      VIDEO: 'Watch the video, read the sentence, and choose the correct word',
      default:
        'Look at the photo, read the sentence, and choose the correct word',
    },
  };

  const typeMap = summaryMap[questionType];
  const summary = typeMap ? typeMap[assetType] || typeMap.default || '' : '';

  console.log('✅ Returning:', {summary, description: summary});

  return {
    summary,
    description: summary,
  };
}
